import { gql } from "@apollo/client";
import DropdownInput from "components/common/form/inputs/dropdown/DropdownInput";
import { graph } from "config/axios-context";
import { DropdownInputPropsType } from "types/form-types";
import { RoomTypeDropdownQuery, RoomTypeDropdownQueryVariables, RoomTypeFilterInput, RoomTypeSortInput } from "types/graphql";
import { appendFilters } from "utilities/datalist/datalist-filter-utilities";
import useAppContext from "utilities/hooks/useAppContext";
import RoomTypeView from "./RoomTypeView";

export type FormRoomTypeType = {
    id: number;
    name: string;
    defaultPrice?: number;
    color?: string;
}

const query = gql`
query RoomTypeDropdown($where: RoomTypeFilterInput, $order: [RoomTypeSortInput!], $skip: Int, $take: Int) {
    roomTypes {
      items(order: $order, skip: $skip, take: $take, where: $where) {
        id
        name
        defaultPrice
        color
      }
    }
  }
`;

type RoomTypeDropdownInputPropsType = Partial<DropdownInputPropsType<FormRoomTypeType, RoomTypeFilterInput, RoomTypeSortInput>> & {
    filters?: RoomTypeFilterInput;
}

const RoomTypeDropdownInput = (props: RoomTypeDropdownInputPropsType) => {
    const context = useAppContext();

    const roomTypeDropdownConfig: DropdownInputPropsType<FormRoomTypeType, RoomTypeFilterInput, RoomTypeSortInput> = {
        name: 'roomType',
        label: 'fields.roomType.name',
        getItemId: (item) => item.id,
        view: {
            inputView: i => i?.name,
            dropdownView: i => <RoomTypeView {...i} />
        },
        dataSource: {
            request: async params => {
                let variables: RoomTypeDropdownQueryVariables = {
                    where: params.filters,
                    order: params.sort,
                    skip: params.skip,
                    take: params.take
                };

                if(props.filters) {
                    variables.where = appendFilters(variables.where, props.filters);
                }

                if (params.searchText) {
                    variables.where = appendFilters(variables.where, {
                        name: {
                            contains: params.searchText
                        }
                    });
                }

                try {
                    const response = await graph<RoomTypeDropdownQuery, RoomTypeDropdownQueryVariables>({
                        query,
                        variables
                    });

                    if (response.errors) {
                        throw response.errors;
                    }

                    return response.data!.roomTypes!.items.map(i => ({
                        id: i.id,
                        name: i.name,
                        defaultPrice: i.defaultPrice,
                        color: i.color || ''
                    }));
                } catch (error: any) {
                    context.notify('error', 't1', Array.isArray(error) ? error[0].message : error.message);
                    throw error;
                }
            }
        }
    }

    const config = {
        ...roomTypeDropdownConfig,
        ...props
    }

    return (
        <DropdownInput
            {...config}
            value={props.value}
        />
    );
};

export default RoomTypeDropdownInput;
